import { render } from "./location_and_direction.vue?vue&type=template&id=5be1052a"
import script from "./location_and_direction.vue?vue&type=script&lang=js"
export * from "./location_and_direction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__